<template>
  <div class="middle-slot transit-line-container">
    <div
      class="transit-line"
      v-bind:class="{'line-bicycle': mode==='BICYCLE','line-walk': (!mode && !isFirst) || mode==='WALK','line-bus': mode==='BUS','line-rail': mode==='RAIL'}"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'transit-line',
  props: {
    mode: String,
  },
};
</script>

<style lang="scss" scoped>
.transit-line-container {
  display: flex;
  justify-content: center;
}

.transit-line {
  border-width: 3px;
}

.line-bicycle {
  border-color: #f93e92;
  border-style: solid;
}
.line-walk {
  border-width: 0 0 0 6px;
  border-color: rgba(192, 195, 216, 0.667);
  border-style: dotted;
  margin: 4px 0;
}

.line-bus {
  border-color: #ff9900;
  border-style: solid;
}
.line-rail {
  border-color: #66cc6f;
  border-style: solid;
}
</style>
